import { render, staticRenderFns } from "./detail_tmdt.vue?vue&type=template&id=f283821e&scoped=true&"
import script from "./detail_tmdt.vue?vue&type=script&lang=js&"
export * from "./detail_tmdt.vue?vue&type=script&lang=js&"
import style0 from "./detail_tmdt.vue?vue&type=style&index=0&id=f283821e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f283821e",
  null
  
)

export default component.exports